module.exports = __webpack_public_path__ + "static/media/10.ff3726ed.png";